export type ClientId = 'haertel' | 'nordictrail' | 'holzwerkstatt' | 'sycotec';

export const clients: { id: ClientId; name: string }[] = [
  { id: 'haertel', name: 'Härtel' },
  { id: 'nordictrail', name: 'Nordictrail' },
  { id: 'holzwerkstatt', name: 'Holzwerkstatt DH' },
  { id: 'sycotec', name: 'SycoTec' },
];
